import { render, staticRenderFns } from "./tab_view.vue?vue&type=template&id=40c2d608&scoped=true"
import script from "./tab_view.vue?vue&type=script&lang=js"
export * from "./tab_view.vue?vue&type=script&lang=js"
import style0 from "./tab_view.vue?vue&type=style&index=0&id=40c2d608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c2d608",
  null
  
)

export default component.exports